import e from "./_baseIsMatch.js";
import m from "./_getMatchData.js";
import c from "./_matchesStrictComparable.js";
var h = e, s = m, i = c;
function n(t) {
  var a = s(t);
  return a.length == 1 && a[0][2] ? i(a[0][0], a[0][1]) : function(r) {
    return r === t || h(r, t, a);
  };
}
var M = n;
export {
  M as default
};
//# sourceMappingURL=_baseMatches.js.map
